import { Component, Input } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ShoppingCartItem } from '../shopping-cart.types';

@Component({
  selector: 'cipx-cart-summary',
  standalone: true,
  imports: [CommonModule, CurrencyPipe],
  template: `
    <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 mb-6">
      <h3 class="text-lg font-semibold mb-3">{{ title }}</h3>

      @if (showItemDetails) {
        <div class="flex justify-between text-sm mb-1">
          <span>Items ({{ getTotalItems() }}):</span>
          <span>{{ getSubtotal() | currency: 'USD' }}</span>
        </div>

        @if (getTax() > 0) {
          <div class="flex justify-between text-sm mb-1">
            <span>Tax:</span>
            <span>{{ getTax() | currency: 'USD' }}</span>
          </div>
        }

        @if (getShipping() > 0) {
          <div class="flex justify-between text-sm mb-1">
            <span>Shipping:</span>
            <span>{{ getShipping() | currency: 'USD' }}</span>
          </div>
        }

        <hr class="my-2" />
      }

      <div class="flex justify-between font-bold text-lg">
        <span>{{ totalLabel }}:</span>
        <span class="text-green-600">{{ getTotal() | currency: 'USD' }}</span>
      </div>

      @if (showItemCount && !showItemDetails) {
        <div class="flex justify-between text-sm mt-1">
          <span>Items:</span>
          <span>{{ getTotalItems() }}</span>
        </div>
      }
    </div>
  `,
  styles: []
})
export class CIPXCartSummaryComponent {
  @Input() items: ShoppingCartItem<any>[] = [];
  @Input() title = 'Cart Summary';
  @Input() totalLabel = 'Total';
  @Input() showItemDetails = true; // Show breakdown of items, tax, shipping
  @Input() showItemCount = false; // Show item count when details are hidden

  // Cart calculation methods
  getTotalItems(): number {
    return this.items.reduce((total, item) => total + item.quantity, 0);
  }

  getSubtotal(): number {
    return this.items.reduce((total, item) => total + item.getSubtotal(), 0);
  }

  getTax(): number {
    return this.items.reduce((total, item) => total + item.getTax(), 0);
  }

  getShipping(): number {
    return this.items.reduce((total, item) => total + item.getShipping(), 0);
  }

  getTotal(): number {
    return this.items.reduce((total, item) => total + item.getTotalWithTaxAndShipping(), 0);
  }
}
